module.exports = __webpack_public_path__ + "media/images/iconInfo__errorRed-6adffaded0484ff7ff9f517bbbcda831.png";